import { throttle } from 'lodash'
import FilterHandler from '@/mixins/filter-handler'
import SearchHandler from '@/mixins/search-handler'
import SharedResource from '@/mixins/shared-resource'
import FabCreate from '@/components/fab-create'
import TickOrCross from '@/components/tick-or-cross'

export default {
  mixins: [SharedResource, FilterHandler, SearchHandler],
  components: {
    FabCreate,
    TickOrCross,
  },
  data() {
    return {
      page: 1,
      loading: false,
    }
  },
  async mounted() {
    await this.getResources()
  },
  methods: {
    getResources: throttle(async function(page = 1) {
      this.loading = true
      this.page = page
      await this.fetchResources({
        search: this.search,
        filters: this.filters,
        paginate: { page, perPage: 10 },
      })
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            text: 'Unable to retrieve resources',
          })
        })
    }, 1000),
  },
}
